export default {
  'courses.tooltips.title': 'Wpisz tytuł tworzonego kursu.',
  'courses.tooltips.subtitle': 'Wpisz podtytuł tworzonego kursu który będzie uzupełnieniem tytułu.',
  'courses.tooltips.summary': 'Ogólnie i zwięźle przedstaw o czym będzie Twój kurs.',
  'courses.tooltips.description':
    'Dodaj dowolny opis do swojego kursu, np. przydatne materiały/słownictwo.',
  'courses.tooltips.active_from': 'Wybierz datę rozpoczęcia Twojego kursu.',
  'courses.tooltips.active_to': 'Wybierz datę zakończenia Twojego kursu.',
  'courses.tooltips.level': 'Wybierz poziom Twojego kursu.',
  'courses.tooltips.target_group': 'Wybierz grupę docelową Twojego kursu.',
  'courses.tooltips.duration': 'Określ czas trwania Twojego kursu w minutach.',
};
